import Vue from 'vue';
import { VCard, VCardText, VRow, VBtn } from 'vuetify/lib';

Vue.component('v-card', VCard);
Vue.component('v-card-text', VCardText);
Vue.component('v-row', VRow);
Vue.component('v-btn', VBtn);

export default Vue.extend({
  template: `
    <v-card style="pointer-events: auto;" class="px-3">
      <v-card-text>
        <v-row align="center" justify="center" v-if="params.isSequence">
          <div class="subtitle-1">sgRNA not annotated in VBC prediction</div>
          <v-btn to="/faq" color="primary" text>
            see FAQs
          </v-btn>
        </v-row>
        <v-row align="center" justify="center" class="subtitle-1" v-else>
          No Rows available.
        </v-row>
      </v-card-text>
    </v-card>
  `,
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  }
});